import { withHandlers, withStateHandlers, compose } from 'recompose'
import { connect } from 'react-redux'

import { postContactForm } from '../../reducers/contact'
import { getOrders } from '../../reducers/orders'
import { getEmailTemplate } from '../../reducers/global'
import getSubscriptionDescription from '../../utils/getSubscriptionDescription'
import _template from 'lodash/template'
import _each from 'lodash/each'
import _get from 'lodash/get'
import moment from 'moment'

const mapDispatchToProps = dispatch => {
  return {
    getOrders: data => dispatch(getOrders(data)),
    postContactForm: data => dispatch(postContactForm(data)),
    getEmailTemplate: name => dispatch(getEmailTemplate(name))
  }
}

export default compose(
  connect(null, mapDispatchToProps),
  withStateHandlers({
    selectedRefundModalId: null,
    isRefundRequestInProgress: false
  },
  {
    hideRefundModal: () => () => ({
      selectedRefundModalId: null
    }),
    showRefundModal: () => id => ({
      selectedRefundModalId: id
    }),
    toggleRefundModalLoading: ({ isRefundRequestInProgress }) => val => {
      if (val) {
        return  ({
          isRefundRequestInProgress: val
        })
      }
      return ({
        isRefundRequestInProgress: !isRefundRequestInProgress
      })
    }
  }),
  withHandlers({
    loadOrders: props => userId => {
      const ordersList = _get(props, 'ordersList', [])
      if (!ordersList.length) {
        props.getOrders({
          size: props.ordersItemsPerPage,
          userId: userId || props.user.id,
          page: props.ordersCurrentPage
        })
      }
    },
    handleOrderPageClick: props => ({ selected }, userId) => {
      props.getOrders({
        size: props.ordersItemsPerPage,
        userId: userId || props.user.id,
        page: selected + 1
      })
    },
    getRefundEmailContent: props => orderDetails => {
      return new Promise((resolve, reject) => {
        const emailParams = {
          ...orderDetails,
          order_items: orderDetails.order_items.map(item => ({
            sku: item.product_id,
            description: getSubscriptionDescription(item.product_id, props.t).description,
            price: item.price
          }))
        }

        props.getEmailTemplate('refund')
          .then(tpl => {
            try {
              const compiled = _template(tpl, {
                imports: {
                  '_each': _each ,
                  'moment': moment
                }
              })
              resolve(compiled({ emailParams }))
            } catch (error) {
              reject(error)
            }

          })
          .catch(e => reject(e))
      })
    }
  }),
  withHandlers({
    confirmRefundRequestSubmit: props => (e, orderDetails) => {
      e.preventDefault()
      props.toggleRefundModalLoading(true)
      props.getRefundEmailContent(orderDetails)

        .then(message => {
          props.postContactForm({
            contactCategory: 3,
            message
          })
          .then(() => {
            props.createNotification({
              type: 'success',
              message: props.t('common:email-refund-sent-success')
            })
            props.hideRefundModal()
            props.toggleRefundModalLoading(false)
          })
          .catch(() => {
            props.createNotification({
              type: 'error',
              message: props.t('common:email-sent-error')
            })
            props.hideRefundModal()
            props.toggleRefundModalLoading(false)
          })
        })
        .catch(() => {
          props.createNotification({
            type: 'error',
            message: props.t('common:email-sent-error')
          })
          props.hideRefundModal()
          props.toggleRefundModalLoading(false)
        })
    }
  })
)



// WEBPACK FOOTER //
// ./components/hoc/loadOrdersHistoryHandler.js